export const BRAND = {
  name: "LAD PERFORMANCE",
  tagline: "Préparation Automobile & Cartographie Éthanol E85",
  address: "56 rue du Stade, 66690 Saint-André",
  phone: "06 75 36 82 90",
  phoneRaw: "+33675368290",
  email: "ladperformance66@gmail.com",
  hours: [
    { day: "Lundi — Vendredi", time: "8h — 18h" },
    { day: "Samedi", time: "Sur rendez-vous" },
    { day: "Dimanche", time: "Fermé" },
  ],
  logo: "https://customer-assets.emergentagent.com/job_lad-performance/artifacts/mbtf1dq0_E0B2C181-DBDD-41AC-B5C8-1E07044D09A0.png",
  heroImage:
    "https://images.unsplash.com/photo-1610374634235-b51ef357f905?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  aboutImage:
    "https://images.pexels.com/photos/8478259/pexels-photo-8478259.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  engineImage:
    "https://images.unsplash.com/photo-1555140713-973b9f36cd1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mapEmbed:
    "https://www.google.com/maps?q=56+rue+du+stade,+66690+Saint-Andr%C3%A9&hl=fr&z=15&output=embed",
};

export const SERVICES = [
  {
    id: "cartographie",
    title: "Cartographie Moteur",
    short: "Stage 1 · Stage 2",
    description:
      "Reprogrammation sur mesure du calculateur moteur pour libérer la puissance réelle de votre véhicule. Gains en couple, en réactivité et optimisation de la consommation.",
    bullets: ["Stage 1 / 2", "Optimisation consommation", "Sauvegarde fichier d'origine"],
    icon: "Cpu",
  },
  {
    id: "ethanol",
    title: "Cartographie Éthanol E85",
    short: "Économie & écologie",
    description:
      "Reprogrammation du calculateur moteur pour rouler au superéthanol E85. Carburant moins cher à la pompe, moins polluant, et gain de performance — sans boîtier ajouté.",
    bullets: ["Reprogrammation sur mesure", "Sans boîtier additionnel", "Sauvegarde fichier d'origine"],
    icon: "Leaf",
  },
  {
    id: "depollution",
    title: "Suppression FAP / EGR / AdBlue",
    short: "Dépollution & fiabilité",
    description:
      "Retrait logiciel et/ou physique des systèmes antipollution problématiques. Fiabilisation du moteur et fin des voyants intempestifs.",
    bullets: ["FAP / DPF off", "EGR off", "AdBlue / NOx off"],
    icon: "Wrench",
  },
  {
    id: "diagnostic",
    title: "Diagnostic Électronique",
    short: "Toutes marques",
    description:
      "Lecture et effacement des codes défauts, diagnostic multimarques approfondi. On identifie le problème avant de toucher au moteur.",
    bullets: ["Multimarques", "Lecture défauts en temps réel", "Rapport détaillé"],
    icon: "ScanLine",
  },
  {
    id: "preparation",
    title: "Préparation Moteur",
    short: "Pour la piste & la route",
    description:
      "Optimisation moteur sur mesure : admission, échappement, turbo, injection. On construit la voiture qui vous correspond, sans compromis.",
    bullets: ["Admission / échappement", "Upgrade turbo", "Suivi personnalisé"],
    icon: "Gauge",
  },
  {
    id: "mecanique",
    title: "Mécanique Toutes Marques",
    short: "Entretien & réparation",
    description:
      "Entretien courant, révision, distribution, embrayage, freinage, suspension. Mécanique générale et réparation toutes marques, essence comme diesel.",
    bullets: ["Révision & vidange", "Distribution / embrayage", "Freinage / suspension"],
    icon: "Settings",
  },
];

export const TESTIMONIALS = [
  {
    name: "Romain L.",
    vehicle: "Peugeot 308 GTi",
    service: "Cartographie Stage 1",
    rating: 5,
    text:
      "Travail au top ! Le gain en couple se ressent dès les premiers tours de roue, et la voiture est beaucoup plus agréable au quotidien. Explications claires avant et après. Je recommande à 100%.",
  },
  {
    name: "Sarah M.",
    vehicle: "Renault Clio IV 1.2 TCe",
    service: "Cartographie Éthanol E85",
    rating: 5,
    text:
      "Je voulais passer à l'E85 sans boîtier additionnel, c'est exactement ce que LAD a fait. Économie réelle à la pompe et la voiture tourne nickel. Accueil professionnel et tarif honnête.",
  },
  {
    name: "Jean-Marc B.",
    vehicle: "BMW 320d",
    service: "Suppression FAP / EGR",
    rating: 5,
    text:
      "Plus de voyant moteur, plus de mode dégradé, la voiture revit. Diagnostic précis dès le départ, intervention propre et fichier de sauvegarde fourni. Atelier de confiance.",
  },
  {
    name: "Tony G.",
    vehicle: "Audi A3 2.0 TDI",
    service: "Diagnostic + Stage 1",
    rating: 5,
    text:
      "J'avais des problèmes que personne n'arrivait à diagnostiquer. LAD a trouvé en moins d'une heure, réparé puis cartographié. Vraiment des passionnés, ça change tout.",
  },
  {
    name: "Eric P.",
    vehicle: "Volkswagen Golf 7 GTI",
    service: "Préparation moteur",
    rating: 5,
    text:
      "Préparation sur mesure pour rouler sur circuit le week-end et au taf en semaine. Suivi personnalisé, conseils techniques au top. La Golf est devenue une vraie machine.",
  },
  {
    name: "Léa D.",
    vehicle: "Citroën C3",
    service: "Mécanique générale",
    rating: 5,
    text:
      "Distribution + révision complète à un prix bien plus juste que chez le concessionnaire. Travail propre, voiture rendue impeccable. Je reviendrai sans hésiter.",
  },
];
